/* @flow */
import React, { Component } from 'react';
import PropTypes from 'react-proptypes';
import { css, names } from 'linaria';

import Size from '../../constants/Size';
import ResponsiveSize from '../../constants/ResponsiveSize';
import { responsiveStyles } from '../../constants/Responsive';
import type { ResponsiveValue } from '../../constants/Responsive';

const GutterSize = 20;

type VerticalAlignment = 'middle' | 'right';

type HorizontalAlignment = 'center' | 'bottom';

class Grid extends Component<{
  vAlign?: VerticalAlignment,
  hAlign?: HorizontalAlignment,
  fit: boolean,
  equalHeight: boolean,
  gutter: boolean,
  children?: any,
  style?: Object,
  className?: string,
}> {
  static childContextTypes = {
    equalHeight: PropTypes.bool,
    gutter: PropTypes.bool,
    fit: PropTypes.bool,
  };

  static defaultProps = {
    fit: false,
    equalHeight: false,
    gutter: false,
  };

  getChildContext() {
    let { fit, equalHeight, gutter } = this.props;
    return { fit, equalHeight, gutter };
  }

  getStyles() {
    let { vAlign, hAlign, gutter, className } = this.props;
    return names(
      Styles.Grid,
      gutter && Styles.GridWithGutter,
      hAlign && Styles.GridAlign[hAlign],
      vAlign && Styles.GridAlign[vAlign],
      className
    );
  }

  render() {
    return (
      <div className={this.getStyles()} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

class GridCell extends Component<{
  size: $Keys<typeof Size> | ResponsiveValue<$Keys<typeof ResponsiveSize>>,
  center: boolean,
  children?: any,
  style?: any,
  className?: string,
  elementRef?: string | Function,
}> {
  static contextTypes = {
    fit: PropTypes.bool,
    equalHeight: PropTypes.bool,
    gutter: PropTypes.bool,
  };

  static defaultProps = {
    center: false,
  };

  getStyles() {
    let { size, center, className } = this.props;
    let { fit, equalHeight, gutter } = this.context;

    return names(
      Size.default,
      fit && Styles.GridCellFit,
      equalHeight && Styles.GridCellEqualHeight,
      gutter && Styles.GridCellWithGutter,
      center && Styles.GridCellCenter,
      typeof size === 'string' ? Size[size] : responsiveStyles(size, k => ResponsiveSize[k]),
      className
    );
  }

  render() {
    let { elementRef, style } = this.props;
    return (
      <div ref={elementRef} className={this.getStyles()} style={style}>
        {this.props.children}
      </div>
    );
  }
}

const Styles = {
  Grid: css`
    box-sizing: border-box;
    display: flex;
    flex-flow: row wrap;
  `,
  GridAlign: {
    center: css`
      justify-content: center;
    `,
    right: css`
      justify-content: flex-end;
    `,
    middle: css`
      align-items: center;
    `,
    bottom: css`
      align-items: flex-end;
    `,
  },
  GridWithGutter: css`
    margin: 0 ${-0.5 * GutterSize}px;
  `,
  GridCellFit: css`
    flex: 1 1 0%;
  `,
  GridCellEqualHeight: css`
    display: flex;
  `,
  GridCellWithGutter: css`
    padding: 0 ${-0.5 * GutterSize}px;
  `,
  GridCellCenter: css`
    align-items: center;
    display: flex;
    flex-direction: column;
  `,
};

export { GridCell };
export default Grid;



// WEBPACK FOOTER //
// ./src/ui/components/core/Grid.js